import { render } from "./UserDropDown.vue?vue&type=template&id=31857fe8&ts=true"
import script from "./UserDropDown.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserDropDown.vue?vue&type=script&setup=true&lang=ts"

import "./UserDropDown.vue?vue&type=style&index=0&id=31857fe8&class=scoped&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lib/components/header/UserDropDown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31857fe8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31857fe8', __exports__)) {
    api.reload('31857fe8', __exports__)
  }
  
  module.hot.accept("./UserDropDown.vue?vue&type=template&id=31857fe8&ts=true", () => {
    api.rerender('31857fe8', render)
  })

}


export default __exports__